module.exports = __webpack_public_path__ + "img/chufa_jiben_icon.10e98338.png";